// ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð·Ð°Ð¿ÑÐ¾ÑÐ° ÑÐ¿Ð¸ÑÐºÐ° Ð»Ð¸Ð´Ð¾Ð². ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð»ÐµÐ¶Ð¸Ñ Ð² Ð°Ð´ÑÐµÑÐµ ÐºÐ°Ðº `all` (ÑÐ°Ðº Ð¶Ðµ, ÐºÐ°Ðº Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð² Ð¸ ÑÐ´ÐµÐ»Ð¾Ðº),
// Ð° Ð±ÑÐº Ð¶Ð´ÑÑ ÐµÐ³Ð¾ Ð² `q`. ÐÑÑÑÐ°Ñ ÑÑÑÐ¾ÐºÐ° Ð² Ð·Ð°Ð¿ÑÐ¾Ñ Ð½Ðµ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÐµÑ.
export const leadsQuery = (params = {}) => {
  const { all, ...rest } = params;
  const text = typeof all === 'string' ? all.trim() : '';
  return text ? { ...rest, q: text } : rest;
};
